import React from 'react'
import { useTranslation } from 'react-i18next'

import StockKeepingUnitInfo from './StockKeepingUnitInfo'
import StockKeepingUnitDetail from './StockKeepingUnitDetail'
import type { StockKeepingUnitFormProps } from 'features/StockKeepingUnit'
import StockKeepingUnitUpload from './StockKeepingUnitUpload'

const StockKeepingUnitForm = ({
  isEdit = false,
  fileList,
  setFileList,
  previousCode,
}: StockKeepingUnitFormProps): JSX.Element => {
  const { t } = useTranslation(['common', 'sku'])

  const base = 'f-stock-keeping-unit__form'

  return (
    <div className={`${base}`}>
      <div className={`${base}__image-layout`}>
        <span className={`${base}__product-detail-title`}>
          {t('sku:product.detail.label')}
        </span>
        <StockKeepingUnitUpload setFileList={setFileList} fileList={fileList} />
      </div>
      <div className={`${base}__description-layout`}>
        <StockKeepingUnitInfo isEdit={isEdit} previousCode={previousCode} />
        <StockKeepingUnitDetail />
      </div>
    </div>
  )
}

export default StockKeepingUnitForm
